module.exports = __webpack_public_path__ + "img/reminders.d51125ca.svg";